<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="instruments"
      :options="options"
      :theme="theme"
      id="instrument-table"
      class="w-100"
    >
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/instrument/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>
      <span slot="description" slot-scope="{ row }">
        {{ row.description }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          class="btn btn-info px-1 py-0 text-white mr-1"
          :href="`#/instrument/${row.id}`"
        >
          <i class="fa fa-eye" />
        </a>
        <a
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/instrument/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <a
          class="btn btn-danger px-1 py-0 text-white mr-1"
          @click="showDeleteModal(row.id)"
        >
          <i class="fa fa-trash" />
        </a>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "InstrumentTable",
  components: {
    ClientTable
  },
  props: {
    instruments: {
      type: Array
    },
    show_columns: {
      type: Array,
      default: () => ["name", "description", "actions"]
    }
  },
  data() {
    return {
      columns: this.show_columns,
      data: this.instruments,
      options: {
        headings: {
          name: "Instrument Name",
          description: "Description"
        },
        sortable: ["name"],
        filterable: ["name"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },
  methods: {
    showDeleteModal(id) {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this instrument. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true
          }
        )
        .then(() => {
          this.$emit("deleteInstrument", id);
        });
    }
  }
};
</script>
